/**
 * "Print drug composition" — sticky printing preference for prescriptions
 * (localStorage-backed, default checked). Shared by the PrescriptionTable
 * header checkbox and every prescription-PDF call site (visit page prints,
 * reports archive re-print), so all prints honor the same last choice.
 */

const KEY = "rxPrintComposition";

export function printCompositionPref(): boolean {
  try {
    return localStorage.getItem(KEY) !== "0";
  } catch {
    return true;
  }
}

export function setPrintCompositionPref(v: boolean): void {
  try {
    localStorage.setItem(KEY, v ? "1" : "0");
  } catch {
    // storage unavailable — session-only
  }
}
